import React, { useEffect, useState } from 'react'
import VendNumber, { round } from 'vend-number'
import { useT } from '@transifex/react'
import { useVdCurrencyFilter } from '../../ng-compat/hooks'
import { useAppSelector } from '../../state/hooks'
import { selectSaleCustomer } from '../../state/slices/currentSale/currentSaleSlice'
import { StoreCreditIssuedData } from '../../modals/store-credit-modal'
import { customerBalancesManager } from '../../managers/customer-balances-manager'

type Props = {
  storeCreditIssuedData: StoreCreditIssuedData
}
export const StoreCreditSummary = (props: Props) => {
  const { transaction, storeCredit } = props.storeCreditIssuedData
  const currentSaleCustomer = useAppSelector(selectSaleCustomer)
  const [storeCreditBalance, setStoreCreditBalance] = useState('')
  const vdCurrencyFilter = useVdCurrencyFilter()
  const t = useT()
  useEffect(() => {
    let balance = 0
    if (storeCredit) {
      balance = storeCredit.balance
      if (currentSaleCustomer) {
        balance = customerBalancesManager.calculateStoreCreditBalance()
      }
    }
    const roundedBalance = round(
      balance,
      2,
      VendNumber.ROUNDING_MODES.ROUND_DOWN
    )
    setStoreCreditBalance(roundedBalance)
  }, [storeCredit, currentSaleCustomer])
  return (
    <ul className="wr-store-credit-summary">
      <li className="wr-store-credit-summary-item">
        <span>
          {t('Store credit issued:', {
            _context: 'Label on store credit issued summary',
          })}
        </span>
        <span>{vdCurrencyFilter(transaction.amount)}</span>
      </li>
      {storeCredit && (
        <li className="wr-store-credit-summary-item">
          <span>
            {t('Store credit balance:', {
              _context: 'Label on store credit issued summary',
            })}
          </span>
          <span>{vdCurrencyFilter(storeCreditBalance)}</span>
        </li>
      )}
    </ul>
  )
}
